import { useHost } from '../hooks/use-host';
import type { XingletLoaderProps } from '../xinglet';

export const XingletLoader: React.FC<XingletLoaderProps> = (props) => {
  const host = useHost();

  return <host.XingletLoader {...props} />;
};
